import React from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { Tooltip } from 'reactstrap';
import * as types from "../../constants/actionTypes";
import GenericInput from "../common/input/GenericInput";
import SectionLoadingError from '../common/SectionLoadingError';
import DataComponent from "../common/DataComponent";
import * as Tools from "../../helpers/Tools";
import MiniSpinner from "../common/MiniSpinner";
import { logUI } from '../../api/andyliticsApi';
import ConfirmationModal from '../common/ConfirmationModal';

export const initialState = {
    showEdit: false,
    newName: "",
    newNameConfirmation: "",
    inputsDisabled: false,
    tooltipOpen: false,
    errors: {
        userNameMismatch: false,
        userNameEmpty: true,
        userNameConfirmationEmpty: true
    }
};

class LoginSettingsUserName extends DataComponent {


    constructor(props) {
        super(props);

        this.state = Tools.deepCopy( initialState);

        this.toggleEdit = this.toggleEdit.bind(this);
        this.toggleTooltip = this.toggleTooltip.bind(this);
        this.save = this.save.bind(this);
        this.handleUserNameInputChange = this.handleUserNameInputChange.bind(this);
        this.closeEdit = this.closeEdit.bind(this);
    }

    componentDidMount() {
        if (super.componentDidMount) { super.componentDidMount(); }
        logUI("MBHWeb.UI.LoginSettingsUserName.ComponentDidMount", new Date(), Tools.getURLPath());
    }

    componentWillUnmount() {
        super.componentWillUnmount();
        const { clearUserNameState } = this.props;
        this.setState(Tools.deepCopy(initialState));
        clearUserNameState();
    }


    toggleEdit() {
        const { showEdit } = this.state;
        const { clearUserNameState, userNameUpdateError } = this.props;
        if (showEdit && userNameUpdateError) {
            clearUserNameState();
        }
        this.setState({ showEdit: !showEdit });

    }

    save() {
        let { newName, newNameConfirmation, errors } = this.state;
        const { changeUserName, userName } = this.props;
        if (!errors.userNameMismatch && !errors.userNameEmpty && !errors.userNameConfirmationEmpty) {
            logUI("MBHWeb.Login.UserName.Change", new Date(), Tools.getURLPath());
            changeUserName(userName, newName, this.closeEdit);
        }
    }

    handleUserNameInputChange(group, event) {
        const { email, userName } = this.props;
        let { newName, newNameConfirmation, inputsDisabled } = this.state;

        const target = event.target;

        if (target.type === 'checkbox') {
            if (target.checked) {
                inputsDisabled = true;
                newName = email;
                newNameConfirmation = email;
            }
            else {
                inputsDisabled = false;
            }
        } else if (target.name === "NewUserNameConfirmation") {
            newNameConfirmation = target.value;
        } else if (target.name === "NewUserName") {
            newName = target.value;
        }

        this.setState({
            newName: newName,
            newNameConfirmation: newNameConfirmation,
            inputsDisabled: inputsDisabled,
            errors: {
                userNameMismatch: newName !== newNameConfirmation,
                userNameEmpty: Tools.isEmptyString(newName),
                userNameConfirmationEmpty: Tools.isEmptyString(newNameConfirmation)
            }
        });

        window.componentChanged = true;

    }

    closeEdit() {
        const { showEdit } = this.state;
        if (showEdit && this._isMounted) {
            this.setState({ showEdit: false });
        }
        window.componentChanged = false;

    }

    clearMessageState() {
        const { clearUserNameState } = this.props;
        clearUserNameState();
    }

    toggleTooltip() {
        this.setState(prevState => ({
            tooltipOpen: !prevState.tooltipOpen
        }));
    }

    render() {

        const { isLoggedIn, userName, userNameUpdateResponse, userNameUpdateError, apiUserNameErrorMessage, userNameChangeIsWaiting} = this.props;
        let { newName, newNameConfirmation, inputsDisabled, errors, tooltipOpen, showEdit } = this.state;
        const enableSave = !errors.userNameMismatch && !errors.userNameEmpty && !errors.userNameConfirmationEmpty;

        return (
            <div className="col-12 list-item-col not-linked">
                <div className="row align-items-end">
                    <div className="col-12 col-sm-6 col-md-3">
                        <div className="list-item-col__label">Username</div>
                    </div>
                    <div className="col-12 col-sm-6 text-left text-sm-right text-md-left">
                        <div className="list-item-col__info">{isLoggedIn && userName}</div>
                    </div>
                    <div className="col-12 col-md-3 text-sm-right">
                        {userNameChangeIsWaiting ? <MiniSpinner /> :
                            <div className="list-item-col__action">{/* Edit should change to Save and Cancel when clicked */}
                                {!showEdit ? <button type="button" className="btn btn-link-style" onClick={() => this.toggleEdit()}>Edit</button> :
                                    <div className="list-item-col__action">
                                        <button type="button" className={"list-item-col__action--save btn btn-link-style" + (!enableSave ? " disabled-style" : "")} disabled={!enableSave} onClick={this.save}>Save</button>
                                        <button type="button" className="list-item-col__action--cancel btn btn-link-style" onClick={this.toggleEdit}>Cancel</button>
                                    </div>
                                }
                            </div>
                        }
                    </div>
                </div>

                {/* Show this below the row above when user edits the username */}
                {showEdit &&
                    <div className="row edit-mode">
                    <div className={"col-12 col-sm-6 form-group" + (!errors.userNameMismatch && !errors.userNameEmpty ? " input-mismatch-password" : "")}>
                            <div className="il-group">
                                <GenericInput type="text"
                                    className={newName && (newName.length > 7) ? " input-invalid" : ""}
                                    disabled={inputsDisabled}
                                    onChange={(e) => this.handleUserNameInputChange('Generic', e)}
                                    value={newName}
                                    required
                                    autoFocus
                                    name="NewUserName"
                                    autoComplete="new-password"
                                    placeholder="New Username"
                                />
                                <div className="input-icon-append">
                                    <span className="icon-info" id="userName" />{/* Add tooltip on hover: "Username must not be less than 8 characters long." */}
                                    <Tooltip placement="top" isOpen={tooltipOpen} autohide={false} target="userName" toggle={this.toggleTooltip}>
                                        Username must not be less than 8 characters long.
                                    </Tooltip>
                                </div>
                            </div>
                        </div>
                    <div className={"col-12 col-sm-6 form-group" + (!errors.userNameMismatch && !errors.userNameConfirmationEmpty ? " input-mismatch-password":"")}>
                        <div className={"il-group" + (newNameConfirmation ? " input-not-empty" : "") + (newNameConfirmation && errors.userNameMismatch ? " input-invalid" : "")}>
                                <GenericInput type="text"
                                    className={(newNameConfirmation && errors.userNameMismatch ? " input-invalid" : "")}
                                    disabled={inputsDisabled}
                                    required
                                    onChange={(e) => this.handleUserNameInputChange('Generic', e)}
                                    value={newNameConfirmation}
                                    name="NewUserNameConfirmation"
                                    autoComplete="new-password"
                                    placeholder="Confirm New Username"
                                />
                                <span className="password-matches">
                                    {!errors.userNameMismatch && !errors.userNameEmpty && <>Username matches</>}
                                </span>
                            </div>
                        </div>
                        <div className="col-12">
                            {!errors.userNameConfirmationEmpty && errors.userNameMismatch &&
                                <div className="error-msg">UserName confirmation doesn’t match. </div>
                            }
                        </div>
                        <div className="col-12">
                            <div className="row">
                                <div className="col-12 col-lg-6">
                                    <label className="checkbox-container">
                                        <input type="checkbox" onChange={(e) => this.handleUserNameInputChange('Generic', e)} />
                                        <span className="checkmark" />
                                        <span className="checkbox-label">Use my email address as my username</span>
                                    </label>
                                </div>
                                <div className="col-12 col-lg-6 text-lg-right">
                                    <div className="change-email">You can update your email in <Link to="/demographics">personal information</Link></div>
                                </div>
                            </div>
                        </div>
                    </div>
                }
                <div className='row'>
                    {userNameUpdateResponse && <div className="col-12 success-msg">Your new username has been saved.</div>}
                    {apiUserNameErrorMessage && <SectionLoadingError message={apiUserNameErrorMessage} />}
                    {userNameUpdateError && <SectionLoadingError message="We're not able to update your username. Please try again later." />}
                </div>
                <ConfirmationModal when={showEdit && (newName !== '' || newNameConfirmation !== '')} />
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        isLoggedIn: state.domain.li,
        userName: state.domain.un,
        userNameUpdateResponse: state.header.userNameResponse,
        userNameUpdateError: state.header.userNameUpdateError,
        apiUserNameErrorMessage: state.header.apiUserNameErrorMessage,
        email: state.domain.e,
        userNameChangeIsWaiting: state.header.userNameChangeIsWaiting
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        changeUserName: (OldUserName, NewUserName, successCallback, failureCallback) => {
            dispatch({
                type: types.CHANGE_USERNAME,
                OldUserName: OldUserName,
                NewUserName: NewUserName,
                successCallback: successCallback,
                failureCallback: failureCallback
            });
        },
        clearUserNameState: () => {
            dispatch({
                type: types.CHANGE_USERNAME_CLEAR
            });
        }
    };
};




export default connect(mapStateToProps, mapDispatchToProps)(LoginSettingsUserName);